export default "__VITE_ASSET__DS_b3wVm__"